import { Delete, MoreVert } from '@mui/icons-material';
import { IconButton, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';

import { translate } from '@/ui/i18n';

export function MoreMenu({
  onClickDelete,
  disabled,
}: {
  onClickDelete: () => void;
  disabled?: boolean;
}) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const onClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const onClose = () => {
    setAnchorEl(null);
  };

  const onClickDeleteItem = () => {
    onClose();
    onClickDelete();
  };

  return (
    <>
      <IconButton onClick={onClick} disabled={disabled}>
        <MoreVert />
      </IconButton>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onClose}>
        <MenuItem onClick={onClickDeleteItem}>
          <Delete sx={{ mr: 1 }} />
          {translate('Form.delete')}
        </MenuItem>
      </Menu>
    </>
  );
}
